<div class="spinner" *ngIf="showSpinner">
  <mat-spinner></mat-spinner>
</div>

<div class="page-container">
  <div class="titles-holder">
    <div class="merck-font-title">Welcome to the specs dashboard!</div>
    <div class="sub-title">Please select between the products!</div>
  </div>

  <div class="options-holder">
    <div class="option-container">
      <div class="option-holder">
        <div class="option-left-holder">
          <div class="option-title-holder">
            <div class="option-title">Customer satisfaction</div>
            <div class="option-subtitle">Coming soon</div>
          </div>
          <div class="option-button inactive">Go</div>
        </div>
      </div>
    </div>
    <div class="option-container">
      <div class="option-holder">
        <div class="option-left-holder">
          <div class="option-title-holder">
            <div class="option-title">solution impact</div>
            <div class="option-subtitle">Coming soon</div>
          </div>
          <div class="option-button inactive">Go</div>
        </div>
        <div class="option-right-holder">
          <!-- <img src="assets/images/mecs-footprint-icon.png" alt="" /> -->
        </div>
      </div>
    </div>
    <div class="option-container">
      <div class="option-holder">
        <div class="option-left-holder">
          <div class="option-title-holder">
            <div class="option-title">Specs footprint dashboard</div>
          </div>
          <div class="option-button" (click)="openMecsDashboard()">Go</div>
        </div>
        <div class="option-right-holder">
          <img src="assets/images/mecs-footprint-icon.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</div>
